export default __webpack_public_path__ + "static/media/login.993b6e38.png";